import { render, staticRenderFns } from "./settList.vue?vue&type=template&id=7ca09472&scoped=true&"
import script from "./settList.vue?vue&type=script&lang=js&"
export * from "./settList.vue?vue&type=script&lang=js&"
import style0 from "./settList.vue?vue&type=style&index=0&id=7ca09472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca09472",
  null
  
)

export default component.exports